<div class="shell">
  <app-user-bar />
  @if (!isAdmin()) {
    <app-header />
  }
  <div class="content">
    <router-outlet />
  </div>
  @if (!isAdmin()) {
    <app-footer />
  }
</div>

<app-login-modal />
<app-confirm-dialog />
